const FALLBACK_URL = 'com';
const DOMAIN_PATTERN = /(omio|goeuro)\./;

const getHostTld = (hostname = ''): string => {
  const isMatch = hostname.match(DOMAIN_PATTERN);

  if (!isMatch) {
    return FALLBACK_URL;
  }

  const lastSegment = hostname.split(DOMAIN_PATTERN).slice(-1)[0];

  return lastSegment || FALLBACK_URL;
};

export default getHostTld;
